<template>
 <v-dialog v-model="dialogDetailUser" persistent style="overflow-y: hidden;">
  <v-card >
  <v-card tile style="box-shadow: none !important;">
      <v-toolbar card style="background: #2562af !important;">
        <v-toolbar-title class="white--text CSChatThai">ข้อมูล</v-toolbar-title>
        <v-spacer></v-spacer>

        <v-btn dark icon flat @click="closeDialog()">
          <v-icon style="color: white !important; font-size: 20px !important;">clear</v-icon>
        </v-btn>
      </v-toolbar>
    </v-card>
  <v-card-text  style="max-height: 80vh;
    overflow: scroll;">
<v-avatar size="100" class="profileBG_White">
                <img :src="backends + UserDetail_who.profile_picture" v-if="UserDetail_who.profile_picture" class="alligator-turtle"/>
                <span class="headline " v-else>{{(UserDetail_who.display_name)? UserDetail_who.display_name.length.charAt(0):''}}</span>
              </v-avatar>


              <div >
<p class="HeadersDetail" style="margin-top: 25px;">ชื่อ</p>
<p class="Detail">{{UserDetail_who.display_name}} </p>
</div>
<div style="margin-top: 20px;">
<p class="HeadersDetail">อีเมล</p>
<p class="Detail">{{UserDetail_who.email}} </p>
</div>

<v-btn class="btnSave" small @click="selectRoom_userOnline()">แชท</v-btn>


    </v-card-text>

</v-card>
</v-dialog>
</template>
<script>
import gql from 'graphql-tag'
import { sync } from 'vuex-pathify'
import { Decode } from '@/services'

const SET_GroupNAME = gql`
mutation ($room_id: uuid, $room_name: String) {
  update_room(where: {room_id: {_eq: $room_id}}, _set: {room_name: $room_name}) {
    returning {
      room_id
    }
  }
}
`

const SET_TIME_READ = gql`
mutation ($user_id: uuid!, $room_id: uuid!) {
  update_member(where: {room_id: {_eq: $room_id}, _and: {user_id: {_eq: $user_id}}}, _set: {time_read: "now()"}) {
    returning {
      time_read
      room_id
      member_id
    }
  }
}
`

export default {
  props: {dialogDetailUser: false, UserDetail_who: {}},
  data () {return {
    user_id: '',
    backends: process.env.VUE_APP_API,
    Authorization: {},
    Groupname: ''
  }},
  created () {
    // this.backends = process.env.VUE_APP_API
    // console.log(this.backends)
    this.user_id = Decode.decodeToken(localStorage.getItem('user_id'))
    this.Authorization = {headers: {'Authorization': 'Bearer ' + Decode.decodeToken(localStorage.getItem('auth_token'))}}
  },
  watch: {
    // dialogDetailUser () {
    //   // console.log(this.backends)
    //   // console.log(this.UserDetail_who)
    //   // this.Groupname = this.roomDetail_SepType.room.room_name
    // }
    // roomDetail_SepType () {
    //   console.log(this.roomDetail_SepType.room.room_name)
    //   // this.Groupname
    // }
  },
  methods: {
    closeDialog () {
      this.$emit('closeDetailUser', false)
    },
    setTimeRead(room_id) {
      this.$apollo.mutate({
        mutation: SET_TIME_READ,
        variables: {
          user_id: this.user_id,
          room_id: room_id
        }
      })
    },
    selectRoom_userOnline() {
      var reqestBody = {
        "user_id": this.user_id,
        "username_friend": this.UserDetail_who.username
      }
      // console.log(reqestBody)
      this.axios.post(process.env.VUE_APP_API + '/createRoomByEmail', reqestBody, this.Authorization).then((response) => {
        // console.log(response.data)
        if (response.data.data.room_id) {
          this.$router.push('/chat_room?id=' + response.data.data.room_id)
          this.setTimeRead(response.data.data.room_id)
        }
        this.closeDialog()
      })
    }
  }
}
</script>
<style type="text/css" scoped>
>>>.v-dialog {
  width: 95vw;
  margin: 0 !important;
  box-shadow: none;
}

>>>.v-text-field--solo input {
    margin: auto !important;
    margin-top: auto !important;
}
>>>.v-text-field--solo>.v-input__control>.v-input__slot {
    background: #3978c7 !important;
    border-radius: 38px !important;
}

>>>.v-input input:focus .v-text-field .v-input__prepend-inner {
  color: red;
}
>>>.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)>.v-input__control>.v-input__slot {
  box-shadow: none;
  font-size: 15px;
}

>>>.theme--light.v-input:not(.v-input--is-disabled) input {
    color: #2562af !important;
}


.v-text-field--box .v-input__slot, .v-text-field--solo .v-input__slot {
  height: 30px;
}


>>>.v-text-field--solo input {
    margin: auto !important;
    margin-top: auto !important;
}
>>>.v-text-field--solo>.v-input__control>.v-input__slot {
    background: #f3f3f3 !important;
    border-radius: 5px !important;
    border: 2px solid #2562af !important;
}

>>>.v-input input:focus .v-text-field .v-input__prepend-inner {
  color: red;
}
>>>.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)>.v-input__control>.v-input__slot {
  box-shadow: none;
}
.btnSave {
  color: white !important;
  background: #2562af !important;
  box-shadow: none !important;
  margin: 20px auto !important;
  display: flex !important;
}

.profileBG_White {
  margin-right: 5px;
  height: 35vw !important;
  width: 35vw !important;
  background: #2562af !important;
  color: white;
  cursor: pointer;
  display: flex;
  margin: auto;
}
.alligator-turtle {
  object-fit: cover;
  object-position: 50% 0;
}
.HeadersDetail {
  margin-bottom: 0 !important;
  color: #5b8cbd8c;
  font-size: 11px; 
}
.Detail {
  color: #5b8cbd;
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/mail/Detail/detail_user.vue